<template>
    <!--Create new tag Modal-->
    <v-dialog persistent v-model="modal" max-width="400">
        <v-card>
            <v-card-title class="primary white--text" :class="{
                'headline': !isMobilePort,
                'caption mobile-title': isMobilePort
            }">
                {{ modalTitle }}
                <v-spacer></v-spacer>
                <v-icon class="primary white--text" @click="closeModal">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="formModel">
                    <v-row>
                        <v-col>
                            <v-text-field hide-detials ref="tagName" class="mx-2 mt-4" v-model="tag.name" :rules="rules"
                                placeholder="Tag Name" flat outlined dense>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="tag.color" v-mask="mask" hide-details class="mx-2 mt-n5" flat
                                outlined dense>
                                <template v-slot:append>
                                    <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16"
                                        :close-on-content-click="true">
                                        <template v-slot:activator="{ on }">
                                            <div :style="swatchStyle" v-on="on" />
                                        </template>
                                        <v-card class="project-tag-color-picker">
                                            <v-card-text class="pa-0">
                                                <v-color-picker v-model="tag.color" flat hide-canvas hide-inputs
                                                    hide-mode-switch show-swatches swatches-max-height="500px"
                                                    :swatches="customSwatches" />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="errorMessage">
                        <v-col class="error--text ml-2 pb-0">{{ errorMessage }}</v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeModal">Cancel</v-btn>
                <v-btn color="primary" @click="saveTag">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mask } from 'vue-the-mask';
import Mobile from '../../inc/mixins/mobile';
import TagsMixins from '../mixins/Tags';
import { EventNames } from '../../../classes/EventNames';
import "vue-swatches/dist/vue-swatches.min.css"
import {showNotification} from "../../../global";

export default {
    data() {
        return {
            modal: false,
            isUpdate: false,
            rules: [val => (val || '').length > 0 || 'This field is required'],
            modalTitle: 'New Project Tag',
            errorMessage: '',
            mask: '!#XXXXXX',
            menu: false,
            tag: this.getTagData(),
            formModel: true,
            customSwatches: [
                ['#FFCDD2', '#F8BBD0', '#E1BEE7', '#D1C4E9', '#C5CAE9'],
                ['#EF9A9A', '#F48FB1', '#CE93D8', '#B39DDB', '#9FA8DA'],
                ['#E57373', '#F06292', '#BA68C8', '#9D80D1', '#7986CB'],

                ['#BBDEFB', '#B3E5FC', '#B2EBF2', '#B2DFDB', '#C8E6C9'],
                ['#90CAF9', '#81D4FA', '#80DEEA', '#80CBC4', '#A5D6A7'],

                ['#DCEDC8', '#F0F4C3', '#FFF9C4', '#FFECB3', '#FFE0B2'],
                ['#C5E1A5', '#E6EE9C', '#FFF59D', '#FFE082', '#FFCC80'],
                ['#AED581', '#DCE775', '#FFF176', '#FFD54F', '#FFB74D'],

                ['#FFCCBC', '#D7CCC8', '#CFD8DC', '#F5F5F5', '#ECEFF1'],
                ['#FFAB91', '#BCAAA4', '#B0BEC5', '#EEEEEE', '#EFEBE9']
            ],
            eventListener: null,
        }
    },
    mixins: [Mobile, TagsMixins],
    directives: {
        mask
    },
    methods: {
        getTagData() {
            return {
                id: 0,
                name: '',
                color: this.$getConst('defaultTagColor'),
            }
        },
        saveTag() {
            let route = this.isUpdate ? 'update_tag' : 'create_new_tag';
            this.errorMessage = '';

            if (this.tag.name.length > 0) {
                this.$http.get(Routing.generate(route, { tag: this.tag }))
                    .then(response => {
                        if (response.data.success === false) {
                            this.errorMessage = response.data.errorMessage;
                        } else {
                            EventBus.fire(EventNames.UPDATE_NOTE_TAGS, response.data.tag);
                            this.closeModal();
                            showNotification('Tag saved successfully', 'success');
                        }
                    })
                    .catch(response => {
                        if (response.status === 409) {
                            this.errorMessage = JSON.parse(response.bodyText).error || 'A tag with this name already exists.';
                        } else {
                            this.errorMessage = 'An unexpected error occurred. Please try again.';
                        }
                        this.$refs.tagName.focus();
                    });
            } else {
                this.$refs.tagName.focus();
            }
        },
        openTagModal(data) {
            this.errorMessage = '';
            this.modalTitle = 'New Project Tag';
            this.isUpdate = false;
            if (data?.isUpdate) {
                this.modalTitle = 'Edit Project Tag';
                this.isUpdate = true;
                if (data.id) {
                    this.tag.id = data.id;
                    this.tag.name = data.name;
                    this.tag.color = data.color;
                } else {
                    let tag = _.find(this.$store.getters.getTags, { 'id': data.tag });
                    if (tag) {
                        this.tag.id = tag.id;
                        this.tag.name = tag.tag;
                        this.tag.color = '#' + tag.color;
                    }
                }
            }
            this.modal = true;
        },
        closeModal() {
            this.tag = {
                name: '',
                color: this.$getConst('defaultTagColor'),
            };
            this.modal = false;
            this.errorMessage = '';
            this.$refs.form.resetValidation();
        }
    },
    mounted() {
        EventBus.listen(EventNames.CREATE_NEW_TAG, this.openTagModal);
    },
    beforeDestroy() {
        EventBus.off(EventNames.CREATE_NEW_TAG, this.openTagModal);
    }
}
</script>

<style>
.project-tag-color-picker .v-color-picker__controls {
    display: none;
}
</style>